(function () {
  const STORAGE_KEY = "techaido-request-quote-products";

  const readProducts = () => {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed.filter((item) => item?.id) : [];
    } catch (error) {
      return [];
    }
  };

  const writeProducts = (products) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(products));
    } catch (error) {
      return;
    }
  };

  const emitUpdate = (products) => {
    window.dispatchEvent(
      new CustomEvent("techaido:request-products-updated", {
        detail: {
          products,
        },
      }),
    );
  };

  const pushEvent = (eventName, payload = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ...payload,
    });
  };

  const hasProduct = (productId) =>
    readProducts().some((product) => String(product.id) === String(productId));

  const addProduct = (product) => {
    const products = readProducts();
    const existing = products.find((item) => String(item.id) === String(product.id));

    if (existing) {
      existing.quantity = Number(existing.quantity) > 0 ? Number(existing.quantity) : 1;
    } else {
      products.push({
        id: String(product.id),
        title: product.title || "",
        url: product.url || "",
        vendor: product.vendor || "",
        image: product.image || "",
        imageAlt: product.imageAlt || "",
        quantity: 1,
        targetPrice: "",
      });
    }

    writeProducts(products);
    emitUpdate(products);
  };

  const updateButtonState = (button) => {
    const isAdded = hasProduct(button.dataset.productId);
    button.classList.toggle("is-added", isAdded);
    button.textContent = isAdded
      ? button.dataset.addedLabel || button.textContent
      : button.dataset.addLabel || button.textContent;
    button.setAttribute("aria-label", button.textContent);
  };

  const updateAllButtons = () => {
    document.querySelectorAll("[data-direct-request-button]").forEach((button) => {
      updateButtonState(button);
    });
  };

  document.addEventListener("click", (event) => {
    const button = event.target.closest("[data-direct-request-button]");
    if (!button) return;

    event.preventDefault();

    const product = {
      id: button.dataset.productId,
      title: button.dataset.productTitle,
      url: button.dataset.productUrl,
      vendor: button.dataset.productVendor,
      image: button.dataset.productImage,
      imageAlt: button.dataset.productImageAlt,
    };

    addProduct(product);

    pushEvent("b2b_request_add_product", {
      source: "collection_card_direct",
      product_id: product.id || "",
      product_title: product.title || "",
      product_vendor: product.vendor || "",
    });

    updateAllButtons();
    window.location.href = button.getAttribute("href") || "/pages/request-quote#selected-products";
  });

  window.addEventListener("storage", (event) => {
    if (event.key !== STORAGE_KEY) return;
    updateAllButtons();
  });

  window.addEventListener("techaido:request-products-updated", updateAllButtons);
  document.addEventListener("DOMContentLoaded", updateAllButtons);
})();
